import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Tab } from '@teorema/patron';
import { CoreConfig } from 'src/app/models/core-config.model';
import { User } from 'src/app/models/user.model';
import { utils } from 'src/app/shared';
import { AuthService } from '../auth.service';
import { MySessionsComponent } from './my-sessions/my-sessions.component';

const TAB_PROFILE = 0;
const TAB_SESSIONS = 1;

@Component({
  templateUrl: './profile.component.html',
  standalone: false,
})
export class ProfileComponent implements OnInit, OnDestroy {
  user?: User;
  formGroup!: FormGroup;
  config!: CoreConfig;
  tabs: Tab[] = [];

  @ViewChild('profileTab') profileTab!: TemplateRef<any>;
  @ViewChild('sessionsTab') sessionsTab!: TemplateRef<any>;
  @ViewChild('mySessions') mySessions?: MySessionsComponent;

  constructor(
    private formBuilder: FormBuilder,
    private titleService: Title,
    private authService: AuthService
  ) {
    this.user = utils.getUser();

    this.formGroup = this.formBuilder.group({
      email: [{ value: this.user.email, disabled: true }],
      name: [{ value: this.user.name, disabled: true }],
    });
  }

  ngOnInit(): void {
    this.config = this.authService.getCoreConfig();
    // O tabview filtra as abas uma única vez no init: o array tem de estar pronto antes dele.
    setTimeout(() => {
      this.titleService.setTitle(`Meu perfil | ${this.config.panelTitle}`);
      this.tabs = [
        { header: 'Meu perfil', template: this.profileTab, index: TAB_PROFILE },
        { header: 'Minhas sessões', template: this.sessionsTab, index: TAB_SESSIONS },
      ];
    });
  }

  tabChanged(index: number) {
    if (index === TAB_SESSIONS) this.mySessions?.init();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.config.panelTitle!);
  }
}
